// extracted by mini-css-extract-plugin
module.exports = {"backgroundMain":"PECBoard_backgroundMain__3yJ98","digitalClock":"PECBoard_digitalClock__9B16M","imgFluid":"PECBoard_imgFluid__1bWh6"};